<!-- Example Parent Component: App.svelte -->
<script>
    import IntervalCalendar from './CalendarioEditavel.svelte';



  import { onMount } from 'svelte'; // Import onMount if needed elsewhere
let funcoesCalendario;
export let usuarioInteragiu = false; // Estado para indicar se o usuário interagiu com o calendário
  // --- Seus dados "template" ---
  // Pode ser o dadosAbril2025 ou qualquer outro que você queira usar como base
  let templateData = {
     
  };

  export let carregou_planilha=false;
let carregado=false;
  // --- Estado para os dados exibidos no calendário ---
  export let calendarData = {}; // Começa vazio ou com dados iniciais
  export let inicial={};
  export let saida = {}; // Começa vazio ou com dados iniciais
  calendarData = saida; // Inicializa com os dados do template
  $: saida=calendarData;
  // --- Estado para seleção de mês/ano ---
  let selectedMonth = new Date().getMonth() ; // Mês atual (1-12)
  let selectedYear = new Date().getFullYear(); // Ano atual

  // --- Função de remapeamento (cole a função remapDatesToMonth aqui) ---
  // Helper para formatar data como YYYY-MM-DD
  // Helper para formatar data como YYYY-MM-DD (pode copiar do IntervalCalendar se preferir)
// Helper para formatar data YYYY-MM-DD (mantenha esta ou similar)
function formatarDataISO(data) {
    if (!(data instanceof Date) || isNaN(data)) return '';
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');
    // Para consistência com UTC usado nos cálculos, podemos formatar a partir de UTC
    const anoUTC = data.getUTCFullYear();
    const mesUTC = (data.getUTCMonth() + 1).toString().padStart(2, '0');
    const diaUTC = data.getUTCDate().toString().padStart(2, '0');
    return `${anoUTC}-${mesUTC}-${diaUTC}`;
}


/**
 * Remapeia as datas de um objeto de dados para um novo mês e ano,
 * baseado na posição ordinal do dia da semana dentro do mês original.
 *
 * @param {object} dadosOriginais - O objeto de dados template (ex: {"2025-04-01": {Intervalos: "..."}})
 * @param {number} mesDestino - Mês de destino (1 a 12)
 * @param {number} anoDestino - Ano de destino (ex: 2025)
 * @returns {object} Um novo objeto com as datas remapeadas.
 */
/**
 * Descobre a posição ordinal de um dia da semana dentro do seu mês.
 * Ex: Se a data for a 3ª quarta-feira do mês, retorna 3.
 * @param {Date} dataObj - O objeto Date para analisar.
 * @returns {number} - A posição ordinal (1, 2, 3, 4 ou 5). Retorna 0 em caso de erro.
 */
function obterPosicaoOrdinalDiaSemana(dataObj) {
    if (!(dataObj instanceof Date) || isNaN(dataObj.getTime())) {
      //  console.error("obterPosicaoOrdinalDiaSemana: Data inválida recebida.");
        return 0; // Retorna 0 ou lança um erro, dependendo da sua preferência
    }

    const diaDoMes = dataObj.getUTCDate();
    const diaDaSemanaAlvo = dataObj.getUTCDay(); // 0 = Domingo, ..., 6 = Sábado
    const mes = dataObj.getUTCMonth();
    const ano = dataObj.getUTCFullYear();

    let contadorOrdinal = 0;
    // Começa no dia 1 do mesmo mês/ano da data original
    const dataIteracao = new Date(Date.UTC(ano, mes, 1));

    // Itera pelos dias desde o início do mês ATÉ o dia da data original
    while (dataIteracao.getUTCDate() <= diaDoMes && dataIteracao.getUTCMonth() === mes) {
        if (dataIteracao.getUTCDay() === diaDaSemanaAlvo) {
            contadorOrdinal++; // Incrementa cada vez que encontramos o dia da semana alvo
        }
        // Se a data da iteração for exatamente a data original, paramos
        if (dataIteracao.getUTCDate() === diaDoMes) {
            break;
        }
        dataIteracao.setUTCDate(dataIteracao.getUTCDate() + 1); // Vai para o próximo dia
    }

    return contadorOrdinal;
}

/**
 * Encontra a data no mês/ano de destino que corresponde a uma posição
 * ordinal específica de um dia da semana.
 * Ex: Encontrar a 3ª Quarta-feira de Junho de 2025.
 * @param {number} mesDestino - O mês de destino (1 a 12).
 * @param {number} anoDestino - O ano de destino.
 * @param {number} diaDaSemanaAlvo - O dia da semana a procurar (0=Domingo a 6=Sábado).
 * @param {number} posicaoOrdinalAlvo - A ocorrência desejada (1, 2, 3, etc.).
 * @returns {Date | null} - O objeto Date correspondente ou null se não encontrado
 *                          (ex: 5ª segunda-feira em um mês com apenas 4).
 */
function encontrarDataPorPosicaoOrdinal(mesDestino, anoDestino, diaDaSemanaAlvo, posicaoOrdinalAlvo) {
     if (posicaoOrdinalAlvo <= 0) return null; // Posição inválida

    const mesDestinoZeroIndex = mesDestino - 1; // Ajusta para 0-11
    let contadorOrdinalAtual = 0;
    const dataIteracao = new Date(Date.UTC(anoDestino, mesDestinoZeroIndex, 1));

    // Itera pelos dias do mês de destino
    while (dataIteracao.getUTCMonth() === mesDestinoZeroIndex) {
        if (dataIteracao.getUTCDay() === diaDaSemanaAlvo) {
            contadorOrdinalAtual++; // Encontrou uma ocorrência do dia da semana
            if (contadorOrdinalAtual === posicaoOrdinalAlvo) {
                // Achou a data exata! Retorna uma cópia dela.
                return new Date(dataIteracao);
            }
        }
        dataIteracao.setUTCDate(dataIteracao.getUTCDate() + 1); // Próximo dia
    }

    // Se saiu do loop sem encontrar (ex: pediu a 5ª qua e só tem 4)
    return null;
}
function remapDatesToMonth(dadosOriginais, mesDestino, anoDestino) {
    const dadosRemapeados = {};
    if (!dadosOriginais || typeof dadosOriginais !== 'object') {
        console.error("remapearDatasParaMes: Dados originais inválidos.");
        return {};
    }
    if (!mesDestino || mesDestino < 1 || mesDestino > 12 || !anoDestino || anoDestino < 1970) {
        console.error("remapearDatasParaMes: Mês ou ano de destino inválido.");
        return {};
    }

    console.log(`--- Iniciando remapeamento para ${mesDestino}/${anoDestino} ---`);

    for (const chaveDataOriginal in dadosOriginais) {
        if (!dadosOriginais.hasOwnProperty(chaveDataOriginal)) continue;

        const dadosIntervalo = dadosOriginais[chaveDataOriginal]; // Os dados associados à data original
        const partesDataOriginal = chaveDataOriginal.split('-');
        if (partesDataOriginal.length !== 3) {
            // console.warn(`Chave de data inválida ignorada: ${chaveDataOriginal}`);
             continue;
        }

        // Cria um objeto Date UTC para análise consistente
        const dataOriginalObj = new Date(Date.UTC(
            parseInt(partesDataOriginal[0]),
            parseInt(partesDataOriginal[1]) - 1, // Mês é 0-indexado
            parseInt(partesDataOriginal[2])
        ));

        if (isNaN(dataOriginalObj.getTime())) {
            // console.warn(`Data original inválida ignorada: ${chaveDataOriginal}`);
             continue; // Pula esta entrada se a data for inválida
        }

        // Passo 1: Descobrir a posição ordinal da data original
        const posicaoOrdinal = obterPosicaoOrdinalDiaSemana(dataOriginalObj);
        if (posicaoOrdinal === 0) {
          //   console.warn(`Não foi possível determinar a posição ordinal para ${chaveDataOriginal}. Ignorando.`);
             continue;
        }

        const diaDaSemanaOriginal = dataOriginalObj.getUTCDay(); // 0=Dom, 1=Seg,...

        // Passo 2: Encontrar a data correspondente no mês/ano de destino
        const dataDestinoEncontrada = encontrarDataPorPosicaoOrdinal(
            mesDestino,
            anoDestino,
            diaDaSemanaOriginal,
            posicaoOrdinal
        );

        // Passo 3: Adicionar aos resultados se encontrada
        if (dataDestinoEncontrada) {
            const novaChaveData = formatarDataISO(dataDestinoEncontrada);
            dadosRemapeados[novaChaveData] = dadosIntervalo;
            // console.log(`  ${chaveDataOriginal} (Pos ${posicaoOrdinal}, Dia ${diaDaSemanaOriginal}) -> ${novaChaveData}`);
        } else {
             const nomeDias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
             console.warn(`  Não foi encontrada a ${posicaoOrdinal}ª ocorrência de ${nomeDias[diaDaSemanaOriginal]} em ${mesDestino}/${anoDestino} para ${chaveDataOriginal}.`);
        }
    }
   // console.log("--- Remapeamento concluído ---", calendarData);
    return dadosRemapeados;
}
  // --- Manipulador de evento do calendário ---
  function handleDataChange(event) {
    // console.log("Parent received data change:", event.detail);
    // Se o usuário edita o calendário, atualizamos nossos dados
    // ATENÇÃO: Isso pode sobrescrever os dados que acabamos de remapear.
    // Talvez você queira uma lógica mais complexa aqui, dependendo do fluxo desejado.
    // Por ora, apenas atualizamos.
    calendarData = event.detail;
  }
  function changeMonth(direction) {
 //   console.log('Mudando mês:', direction.detail);
    let json = direction.detail;
    
    if (json.direction === 'prev') {
      selectedMonth--;
      if (selectedMonth < 0) { selectedMonth = 11; selectedYear--; }
    } else {
      selectedMonth++;
      if (selectedMonth > 11) { selectedMonth = 0; selectedYear++; }
    }
  
    templateData = json.outputData; // Atualiza o templateData com os dados do evento
    applyRemapping(); // Aplica o remapeamento após a mudança de mês/ano
  }
  // --- Função para aplicar o remapeamento ---
  function applyRemapping() {
   // carregado=false;
  //  console.log(`Remapeando template para ${selectedMonth}/${selectedYear}...`);
    const newData = remapDatesToMonth(templateData, parseInt(selectedMonth+1), parseInt(selectedYear));
  //  console.log("Novos dados gerados:", newData);
    calendarData = newData; // Atualiza os dados do calendário!
    carregado=true;
    funcoesCalendario.Inicializa(calendarData);
   // funcoesCalendario.CarregouPlanilha()
    // O IntervalCalendar vai reagir a essa mudança em `calendarData`.
  }

  // --- Opções para os selects ---
  const months = [
    { value: 1, name: 'Janeiro' }, { value: 2, name: 'Fevereiro' }, { value: 3, name: 'Março' },
    { value: 4, name: 'Abril' }, { value: 5, name: 'Maio' }, { value: 6, name: 'Junho' },
    { value: 7, name: 'Julho' }, { value: 8, name: 'Agosto' }, { value: 9, name: 'Setembro' },
    { value: 10, name: 'Outubro' }, { value: 11, name: 'Novembro' }, { value: 12, name: 'Dezembro' }
  ];
  const currentFullYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentFullYear - 5 + i); // Ex: 5 anos para trás e 4 para frente

  // Aplica o remapeamento inicial para o mês/ano atual ao montar
  onMount(async () => {
      await calendarData; 
     await saida;
     await inicial;
      await applyRemapping();
//      console.log("Dados iniciais aplicados:", inicial);
     funcoesCalendario.CarregouPlanilha()
  });

</script>


<IntervalCalendar bind:this={funcoesCalendario} on:mudou_mes={changeMonth} currentMonth={selectedMonth} currentYear={selectedYear} dados_inicias= {calendarData} outputData={calendarData} on:dataChange={handleDataChange}  {carregou_planilha}/>



<style>
  label { margin-right: 5px; font-weight: bold; }
  select, button { padding: 5px 8px; font-size: 0.95em; margin-right: 5px; border-radius: 3px; border: 1px solid #ccc; }
  button { cursor: pointer; background-color: #007bff; color: white; border-color: #007bff; }
  button:hover { background-color: #0056b3; border-color: #0056b3; }
  pre { background-color: #eee; padding: 10px; border-radius: 4px; font-size: 0.85em; white-space: pre-wrap; word-break: break-all; }
</style>